import React, { useEffect, useState } from "react";
import { offBoardingService } from "../../../api/services/offBoardingService";
import { setLoading } from "../../../infra/aggregates/LoaderSlice";
import { setOffBoardingList } from "../../../infra/aggregates/myProfile/offBoardingAggregates/offBoardingListSlice";
import { setOffBoardingWithdrawn } from "../../../infra/aggregates/myProfile/offBoardingAggregates/offBoardingWithdrawnSlice";
import { useAppDispatch, useAppSelector } from "../../../infra/hooks";

interface PropsValue {
  setOffBoardingListData: (data: any) => void;
  setOffBoardingWithdrawnData: (data: any) => void;
}
function DTOOffBoarding({
  setOffBoardingListData,
  setOffBoardingWithdrawnData,
}: PropsValue) {
  const selector = useAppSelector((state) => state.authSlice);
  const storedOffboarding = useAppSelector(
    (state) => state.offBoardingListSlice.offBoardingList
  );
  const storedOffboardingWithdrawn = useAppSelector(
    (state) => state.offBoardingWithdrawnSlice.offBoardingWithdrawn
  );
  const dispatch = useAppDispatch();

  const getOffBoardingList = (companyId: number, empId: number) => {
    dispatch(setLoading(true));
    offBoardingService
      .getEmpBoarding(companyId, empId)
      .then((response: any) => {
        if (response.response == "success") {
          dispatch(setOffBoardingList(response?.data));
          setOffBoardingListData(response?.data);
          dispatch(setLoading(false));
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  };

  const getOffBoardingWithdrawnList = (companyId: number, empId: number) => {
    dispatch(setLoading(true));

    offBoardingService
      .getEmpBoardingWithdrawn(companyId, empId)
      .then((response: any) => {
        if (response.response == "success") {
          dispatch(setOffBoardingWithdrawn(response?.data));
          setOffBoardingWithdrawnData(response?.data);
          dispatch(setLoading(false));
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  };

  useEffect(() => {
    if (selector.company_id && selector.emp_id) {
      getOffBoardingList(selector.company_id, selector.emp_id);
      getOffBoardingWithdrawnList(selector.company_id, selector.emp_id);
    }
  }, []);

  useEffect(() => {
    setOffBoardingListData(storedOffboarding);
    setOffBoardingWithdrawnData(storedOffboardingWithdrawn);
  }, [storedOffboarding, storedOffboardingWithdrawn]);

  return <></>;
}
export default DTOOffBoarding;
